import { z } from "zod";
import {
  LaserficheConfigurationSchema,
  LaserficheInspectDirectoryItemSchema,
  LaserficheDirectorySchema,
  LaserficheInspectFieldSchema,
  LaserficheInspectTagSchema,
  LaserficheInspectTemplateSchema,
  LaserficheConnectionDtoSchema,
  LaserficheInternalConfigurationSchema,
} from "../../models/integrations.schema";

export const PrivateLaserficheIntegrationControllerResponseSchema = {
  integrationLaserficheCreateSelfhosted: z.boolean(),

  integrationLaserficheCreateCloudhosted: z.boolean(),

  integrationLaserficheGetConnection: LaserficheConnectionDtoSchema.nullable(),

  integrationLaserficheListConnections: z.record(
    z.string(),
    LaserficheConnectionDtoSchema.nullable()
  ),

  integrationLaserficheDeleteConnection: z.boolean(),

  integrationLaserficheInspectFields: LaserficheInspectFieldSchema.array(),

  integrationLaserficheInspectTemplates:
    LaserficheInspectTemplateSchema.array(),

  integrationLaserficheInspectTags: LaserficheInspectTagSchema.array(),

  integrationLaserficheInspectDirectory:
    LaserficheInspectDirectoryItemSchema.array().nullable(),

  integrationLaserficheGetConfigDirectory: z
    .object({
      primary: LaserficheDirectorySchema.optional(),
      orphanSigned: LaserficheDirectorySchema.optional(),
    })
    .nullable(),

  integrationLaserficheConfigDirectory: z.boolean(),

  integrationLaserficheGetConfigMetadata:
    LaserficheConfigurationSchema.shape.metadata.nullable(),

  integrationLaserficheConfigMetadata: z.boolean(),

  integrationLaserficheDeleteConfigMetadata: z.boolean(),

  integrationLaserficheGetInternalConfig:
    LaserficheInternalConfigurationSchema.nullable(),

  integrationLaserficheUpdateInternalConfig: z.void(),

  integrationLaserfichePushMeetingMinutes: z.object({
    success: z.boolean(),
    errors: z.string().optional(),
  }),
};
